<template>
    <div v-if="schema.read_only && schema.type != 'visiblereadonly'" :data-readonly="name">
        <!-- Ignore read-only fields -->
    </div>
    <div v-else class="form-row control-group" :class="{error: hasErrors}">
        <label :for="name" class="control-label"
               v-bind:class="{'schema-required': isRequired}">{{schema.label}}</label><!--  col-sm-3 col-form-label -->

        <div class="controls">
            <!-- textarea -->
            <!-- .profile-answer should give similar styling to actual search field -->
            <div v-if="schema.type == 'textarea'"
                 class="profile-answer">
                <trumbowyg
                    :config="TRUMBOWYG_CONFIG"
                    :name="name"
                    v-model="localValue"
                    @tbw-change="inputValue"
                ></trumbowyg>
            </div>

            <!-- textarea_plain -->
            <textarea v-else-if="schema.type == 'textarea_plain'"
                class="form-control widget-embed" v-bind:class="{'is-invalid': errors}"
                rows="4"
                :name="name"
                :required="isRequired"
                @input="inputValue"
                v-model="localValue"
            ></textarea>

            <!-- embed -->
            <textarea v-else-if="schema.type == 'embed'"
                class="form-control widget-embed" v-bind:class="{'is-invalid': errors}"
                rows="4"
                :name="name"
                :required="isRequired"
                @input="inputValue"
                v-model="localValue"
            ></textarea>

            <!-- choice: dropdown -->
            <select v-else-if="schema.type == 'choice'" class="form-control"
                    v-model="localValue"
                    v-bind:class="{'is-invalid': errors}"
                      :name="name" :required="isRequired" @change="changeValue">
                <option v-for="choice in schema.choices" :key="choice.id"
                        :value="choice.value" :selected="choice.value == value">{{ choice.display_name }}</option>
            </select>

            <!-- radio boxes -->
            <template v-else-if="schema.type == 'list'">
                <div v-for="choice in schema.choices" :key="choice.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            class="form-check-input" type="radio" :name="name"
                            @change="changeValue"
                            v-bind:class="{'is-invalid': errors}"
                            :value="choice.value"
                            v-model="schema.choices"
                            :checked="choice.value == value">
                        {{ choice.display_name }}
                    </label>
                </div>
            </template>
            <!-- multiselect: checkboxes -->
            <template v-else-if="schema.type == 'multiple choice'">
                <div v-for="choice in schema.choices" :key="choice.id" class="form-check">
                    <label class="form-check-label">
                        <input
                            class="form-check-input" type="checkbox" :name="name"
                            @change="updateMultiValue"
                            v-bind:class="{'is-invalid': errors}"
                            :value="choice.value"

                            :checked="isCurrentChoice(value, choice.value)">
                        <!-- v-model="schema.choices" -->
                        <!--  value.includes(choice.value) 'value' should be an array -->
                        {{ choice.display_name }}
                    </label>
                </div>
            </template>
            <!-- checkbox -->
            <div v-else-if="schema.type == 'boolean'" class="form-check">
                <label class="form-check-label">
                    <input
                        class="form-check-input" type="checkbox" :name="name"
                        v-bind:class="{'is-invalid': errors}"
                        v-model="localValue"
                        value="1"
                        @change="changeValue"
                    ><!--  value.includes(choice.value) 'value' should be an array -->
                     <!-- {{ choice.display_name }} ...where did choice come from? -->
                </label>
            </div>

            <!-- Upload image -->
            <div v-else-if="schema.type == 'image upload'" class="form-upload">
                <img v-if="value" :src="UrlImageGravatar(value)" class="form-upload-gravatar" />

                <input type="file" class="form-control" v-bind:class="{'is-invalid': errors}"
                :name="name"
                @change="changeValue"
                accept="image/*"
                />
            </div>

            <!-- Upload file -->
            <div v-else-if="schema.type == 'file upload'" class="form-upload">
                <input
                    type="file" class="form-control" v-bind:class="{'is-invalid': errors}"
                    :name="name"
                    @change="changeValue"/>
                <a v-if="value" :href="UrlFileRaw(value)" class="form-upload-file" target="_blank">
                    Current file
                </a>
            </div>

            <!-- Password -->
            <input v-else-if="schema.type == 'password'"
                type="password" class="form-control"
                v-bind:class="{'is-invalid': errors}"
                :name="name" v-model="localValue"
                :minlength="minlength"
                :required="isRequired"
                @input="inputValue"/><!-- :value="value" -->

            <!-- Visible read-only faux input -->
            <input v-else-if="schema.type == 'visiblereadonly'"
                type="text" class="form-control"
                v-model="localValue"
                disabled>

            <!-- Nested elements e.g. on Register form -->
            <div v-else-if="isNested" class="form-nested-fields">
                <SchemaField
                    v-for="(sfield, key) in schema.children"
                    :key="key" :name="key" :schema="sfield"
                    :value="value ? value[key] : null"
                    @input="updateNestedKeyPair"
                    @change="updateNestedKeyPair"

                    :errors="errors ? errors[key]: null"
                /><!--
                @change="inputChangeEvent"

                form[key] -> value[key] -->
            </div>

            <!-- text (fallback -->
            <input v-else type="text" class="form-control" v-bind:class="{'is-invalid': errors}"
                :name="name" v-model="localValue"
                :minlength="minlength"
                :required="isRequired"
                @input="inputValue"
            /><!-- :value="value"
                  :required="schema.required" -->

            <!-- Help and error messages -->
            <div v-if="!isNested">
                <small v-if="schema.help_text" class="help-block form-text" v-html="schema.help_text"></small>

                <div v-if="hasErrors" class="invalid-feedback">
                    <div v-for="(error, key) in errors" :key="key" class="help-block">{{ error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // TODO: Consider https://vueformulate.com/ ?
    /**
     *
            "initial": {
                "type": "field",
                "required": false,
                "read_only": true,
                "label": "Initial",
                "allow_blank": true
            },
            "last_name": {
                "type": "string",
                "required": false,
                "read_only": false,
                "label": "Last name",
                "max_length": 150,
                "allow_blank": false
            },
            cf28: {
                type: "multiple choice",
                required: true,
                read_only: false,
                label: "Opportunities",
                choices: [
                    {value: "alpha", display_name: "alpha"},
                    {value: "beta", display_name: "beta"},
                    …]
     *
     */
    import Trumbowyg from 'vue-trumbowyg';
    // Import editor css
    import 'trumbowyg/dist/ui/trumbowyg.css';

    import isEmpty from 'lodash/isEmpty';
    import { TRUMBOWYG_CONFIG, UrlFileRaw, UrlImageGravatar } from './Config';

    export default {
        name: "SchemaField",
        props: {
            name: {
                type: String,
                required: true
            },
            schema: {
                type: Object,
                required: true
            },
            errors: {
                type: Array,
                required: false
            },
            value: [String, Number, Array, Boolean],
            // inputChangeEvent: { // Used to pass the input/change event handler into child fields
            //     type: Function
            // }
        },
        data() {
            return {
                TRUMBOWYG_CONFIG,
                localValue: this.initialValue(), // this.value,
            }
        },
        components: {
            Trumbowyg
        },
        computed: {
            isNested() {
                return this.schema.type == 'nested object';
            },
            isRequired() {
                /* Actually uses the inverse of the schema.allow_blank value */
                return ! this.schema.allow_blank;
            },
            hasErrors() {
                if (!this.errors) { return false; }
                return Boolean(this.errors.length);
            },
            minlength() {
                if (this.schema.min_length) {
                    return this.schema.min_length;
                } else {
                    return false;
                }
            }
        },
        methods: {
            isEmpty,
            UrlFileRaw,
            UrlImageGravatar,
            initialValue() {
                var initial = '';
                if ("default" in this.schema) {
                    initial = this.schema.default;
                }
                if ("undefined" !== typeof this.value) {
                    initial = this.value;
                }
                console.log(`Setting initial value of ${this.name} to ${initial}`);
                return initial;
            },
            inputValue(event) {
                // this.$emit('input', event.target.value)
                console.log(this.name, event);
                let curName = this.name;
                let payload = {};
                //payload[curName] = event.target.value
                payload[curName] = this.localValue; // || this.value;
                this.$emit('input', payload);
            },
            changeValue(event) {
                let curName = this.name;
                let payload = {};
                payload[curName] = this.localValue;
                console.log("CHANGE!", event, payload);
                this.$emit('change', payload);
            },
            updateMultiValue(event) {
                let curName = this.name;
                let payload = {};
                console.log("updateMultiValue", curName);
                const checked = [];
                const allBoxes = document.getElementsByName(event.target.name);

                allBoxes.forEach(box => {
                    if (box.checked) {
                        checked.push(box.value);
                    }
                });
                payload[curName] = checked;
                this.$emit('input', payload);
            },

            /** Only used with nested objects
             *
             * localValue is an object when this.isNested.
             * Add the keypair to it and trigger a new 'input' event with this object.
             * @param payload Object
             */
            updateNestedKeyPair(payload) {
                // Ensure localValue is an object now (doing it via initialValue() doesn't seem to work)
                if (!this.localValue) { this.localValue = {}; }

                Object.assign(this.localValue, payload);
                let nested = {};
                nested[this.name] = this.localValue;
                this.isEditing = true;
                this.$emit('input', nested);
            },

            isCurrentChoice(choices, value) {
                if (Array.isArray(choices)) {
                    if (choices.indexOf(value) >= 0) {
                        return true;
                    }
                    return false;
                }
                // Assume this is a dictionary
                if (choices && choices.includes(value)) {
                    return true;
                }
                return false;
            }
        }
    }
</script>

<style>
label.schema-required {
  font-weight: bold;
}
textarea.widget-embed {
  width: 80%;
}
.form-upload-gravatar {
    float: right;
}
.profile-answer .trumbowyg-box {
    margin: 0;
    box-sizing: border-box;
}
.form-horizontal .form-row small.help-block {
    margin-top: 0;
}

</style>